import { assert } from '../../common/assert.js'
import { Day } from '../../common/day.js'
import { Month } from '../../common/month.js'
import type { State } from '../types.js'

export const isPaymentMethodExpiring = (state: State): boolean => {
    const { billing } = state.portal

    if (!billing) {
        return false
    }

    const month = Month.fromYm(billing.mitExpiryMonth)

    // For example, if a card expires in 01/2026, we consider it expiring as of 2025-12-01
    const threshold = month.addMonths(-1).firstDay()

    // Timezone is not very important here
    const today = Day.today('UTC')

    return today.isAfter(threshold)
}

export const getExpiringPaymentMethodDueDate = (state: State) => {
    const { billing } = state.portal
    assert(billing)

    // mitExpiryMonth is in YYYY-MM format
    const month = Month.fromYm(billing.mitExpiryMonth)

    // If the card expires in 01/2026, we should use 2026-02-01 here.
    // It should match the due date of the next invoice and we currently use the first of month as the due date.
    return month.addMonths(1).firstDay()
}
